export class IframeLink {
    /** 唯一标识 tabId */
    id: string;

    code: string; // 编号
    FuncName: string; // 名称
    appType: string; // 应用类型 menu app
    funcId: string;
    appId: string;
    appEntrance: string;
    /** iframe所加载功能的url及querystring参数运行时拼接 */
    src: string;
    /** iframe所加载功能的url */
    url: string;

    active = false;
    /** 当前iframe对应的功能session */
    sessionid: string;

    reload: boolean;
    /** 是否为jQuery原生开发 */
    isjquery: boolean;

    /**
     * spa模式下重复打开功能
     * true：构造新的页面实例
     * false || null || undefined：复用已打开的页面实例
     */
    isNewTab: boolean;

    /** 标签页打开方式: spa mdi */
    mode: string;
    /** 菜单部署su信息 */
    su: string;

    /**
     * 当前表单的公共变量token
     */
    formToken: string;

    tId: string;

    /**
     * 菜单页签切换控制实体
     */
    switchControl: any;

    constructor(code: string, sessionid: string, src = '', active = false) {
        this.code = code;
        this.src = src;
        this.active = active;
        this.sessionid = sessionid;
    }
}
